import {type PIXI} from '@colonist/pixi'
import {type UIGameManager} from '../UIGameManager.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {UIHoverActionController} from './UIHoverActionController.ts'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorRoad} from '@colonist/game-mechanic-validators'
import {type MechanicRoadState} from '@colonist/game-states'

export class UIRoadHoverActionController extends UIHoverActionController {
    private readonly roadValidator: MechanicValidatorRoad

    constructor(uiGameManager: UIGameManager, roadState: MechanicRoadState) {
        super(uiGameManager)
        this.resources = getCardsForPiece(PieceTypes.Road)

        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildRoadSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileEdgeHoverAction(this)
        this.roadValidator = new MechanicValidatorRoad(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, roadState)
    }

    getBankActionAmount(index: number): number {
        const myRoadPlayerState = this.roadValidator.getRoadPlayerState(this.uiGameManager.gameController.myColor)
        return myRoadPlayerState.bankRoadAmount
    }

    protected updateState() {
        const useResources = true
        const canPlaceRoad = this.roadValidator.canPlayerPlaceRoad(this.uiGameManager.gameController.myColor, useResources)

        this.updateHoverLocations(canPlaceRoad.validHoverLocations, canPlaceRoad.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getRoadForPlayer(this.uiGameManager.gameController.myColor)
    }
}
